import React from "react";
import ReactConfetti from "react-confetti";

export default function Confetti({ hide }) {
  if (hide) return null;

  return (
    <ReactConfetti
      width={window.innerWidth}
      height={window.height}
      recycle={false}
      numberOfPieces={250}
      tweenDuration={15000}
    />
  );
}
